import { useNavigate, useParams, useLocation } from 'react-router-dom';
import React from 'react';

export interface RouterProps<Params = any> {
    navigate: ReturnType<typeof useNavigate>;
    params: Params;
    location: ReturnType<typeof useLocation>;
    // Legacy compatibility
    match: { params: Params };
    history: { push: (path: string) => void };
}

export function withRouter<P extends RouterProps>(
    Component: React.ComponentType<P>
): React.FC<Omit<P, keyof RouterProps>> {
    return (props: Omit<P, keyof RouterProps>) => {
        const navigate = useNavigate();
        const params = useParams();
        const location = useLocation();
        
        const routerProps = {
            navigate,
            params,
            location,
            match: { params },
            history: { push: navigate },
        } as RouterProps;

        return <Component {...(props as P)} {...routerProps} />;
    };
}

